import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, DialogTitleProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Button from '../button';

type WizardDialogTitleProps = Omit<DialogTitleProps, 'title'>;

interface Props extends WizardDialogTitleProps {
  className?: string;
  isFirstStep?: boolean;
  onBack?: () => void;
  isLastStep?: boolean;
  onContinue?: () => void;
}

const WizardDialogTitleImpl: React.FC<Props> = ({
  className,
  isFirstStep,
  onBack,
  isLastStep,
  onContinue,
  children,
}) => {
  return (
    <DialogTitle className={className}>
      <div className="left-action">
        {!!onBack && (
          <Button
            className="v2-icon-button"
            color="inherit"
            icon={isFirstStep ? CloseIcon : ArrowBackIcon}
            onClick={onBack}
            size="large"
          />
        )}
      </div>
      <div className="title-area">{children}</div>
      <div className="right-action">
        {!isLastStep && !!onContinue && (
          <Button onClick={onContinue}>Continue</Button>
        )}
      </div>
    </DialogTitle>
  );
};

/**
 * A convenience wrapper around `<DialogTitle/>` that adds an icon and a title.
 *
 * This is meant to be used with `<WizardDialog/>`
 */
export const WizardDialogTitle = muiStyled(WizardDialogTitleImpl)(
  ({ theme }) => css`
    padding-top: 50px;
    display: flex;

    .v2-icon-button {
      padding: 0;
      .MuiSvgIcon-root {
        color: ${theme.palette.text.primary};
        font-size: 36px;
      }
    }

    .title-area .MuiTypography-root {
      color: ${theme.palette.text.primary};
    }

    .left-action,
    .right-action {
      /* Allocate this space for holding action buttons, increase if
         space not enough to hold all of buttons */
      flex-basis: 100px;
    }
    .right-action {
      text-align: right;
    }

    .title-area {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${theme.palette.text.primary};
    }
  `
);
